import { useMsal } from "@azure/msal-react";
import { Button, Modal, Stack, Text } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { memo } from "react";
import { deleteResponse } from "src/utils/deleteChats";
import type { MessageEntity } from "../db";

export const DeleteMessageEntityItemModal = memo(function DeleteMessageEntityItemModal({
    message,
    isOpen,
    close,
}: {
    message: MessageEntity;
    isOpen?: boolean;
    close?: () => void;
}) {
    const navigate = useNavigate();
    const { instance } = useMsal();

    return (
        <Modal
            data-testid="delete-modal"
            opened={Boolean(isOpen)}
            onClose={close || (() => {})}
            title="Delete Message"
        >
            <form
                onSubmit={async (event) => {
                    try {
                        event.preventDefault();
                        deleteResponse(message, instance, navigate);
                    } catch (err) {
                        console.error("Failed to delete message:", err);
                    }
                }}
            >
                <Stack>
                    <Text size="sm">Are you sure you want to delete this chat?</Text>
                    <Button data-testid="delete-chat-button" type="submit" color="red">
                        Delete
                    </Button>
                </Stack>
            </form>
        </Modal>
    );
});
